import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'phone-icon',
  templateUrl: './phone-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PhoneIconComponent {}
